import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SubscriptionPlans from '../SubscriptionPlans/SubscriptionPlans';
import PaymentModal from '../PaymentModal/PaymentModal';
import TermsConditions from '../TermsConditions/TermsConditions';
import { API_BASE_URL } from '../../config/api';
import './SubscriptionPage.css';

const SubscriptionPage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [hasPurchasedPlan, setHasPurchasedPlan] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) return;

        const res = await fetch(`${API_BASE_URL}/api/v1/paypal/current-subscription`, {
          headers: { 'Authorization': `Bearer ${authToken}` },
        });

        if (res.ok) {
          const data = await res.json();
          setHasPurchasedPlan(data.status === 'COMPLETED');
        }
      } catch {
        // ignore
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscription();
  }, []);

  if (isLoading) {
    return (
      <div className="subscription-page">
        <div className="subscription-page-loading">
          <div className="subscription-page-spinner" />
          <p>Loading plans...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-page">
      <div className="subscription-page-header">
        <button
          className="subscription-back-btn"
          onClick={() => navigate('/home')}
          aria-label="Back to home"
        >
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </button>
        <h1 className="subscription-page-title">Subscription Plans</h1>
      </div>

      <SubscriptionPlans
        selectedPlan={selectedPlan}
        onSelectPlan={(plan) => setSelectedPlan(plan)}
        onContinue={() => setShowPaymentModal(true)}
        onShowTerms={() => setShowTerms(true)}
        hasPurchasedPlan={hasPurchasedPlan}
      />

      {showPaymentModal && (
        <PaymentModal
          onClose={() => setShowPaymentModal(false)}
          onSuccess={() => {
            setShowPaymentModal(false);
            setHasPurchasedPlan(true);
            setSelectedPlan(null);
            navigate('/home');
          }}
          selectedPlan={selectedPlan || undefined}
        />
      )}

      {showTerms && <TermsConditions onClose={() => setShowTerms(false)} />}
    </div>
  );
};

export default SubscriptionPage;
